var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.date)+" "),(_vm.time)?_c('span',[_vm._v(_vm._s(_vm.timeV))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }